import { unsafeCSS, html } from "lit";
import { BaseValueProp } from "../../base/value-prop/value-prop.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  --leafdcws-value-prop-icon-height: 80px;\n  --leafdcws-value-prop-icon-width: 80px;\n}";
const _CHCValueProp = class _CHCValueProp extends BaseValueProp {
  render() {
    return html`<div class="chc-c-value-prop">${super.render()}</div>`;
  }
};
_CHCValueProp.styles = unsafeCSS([BaseValueProp.styles, styles]);
let CHCValueProp = _CHCValueProp;
export {
  CHCValueProp
};
//# sourceMappingURL=value-prop.component.js.map
